// Module
var code = `<div appHeaderBar>
    <header-bar-title>Edit Payment Schedule Day</header-bar-title>
</div>

<ng-container  *ngIf="doneLoading">
    <app-page-content [showWebFooter]="true" [usePagePadding]="true">

        <app-cobrand-header [property]="property.nickname"
                            [manager]="property.hoa.pmc.name"
                            [association]="property.hoa.name">
        </app-cobrand-header>

        <form name="PaymentScheduleView"
              id="PaymentScheduleView"
              tid="PaymentScheduleView"
              #paymentScheduleView="ngForm">
            <div class="HOA-container">
                <div class="HOA-container__header">
                    <div class="HOA-container__header-text" tid="scheduleNicknameHeader">
                        <span>Edit Fixed Payment Day</span>
                        <div class="u-floatRight">
                            <button name="cancelButton"
                                    id="cancel1"
                                    tid="cancelButton"
                                    type="cancelButton"
                                    class="Button Button--link "
                                    [routerLink]="['/properties/scheduleEdit', paymentSchedule.id]"
                                    [state]="{scheduleId: paymentSchedule.id}">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="HOA-misc-guidedSteps__container">
                <div class="HOA-misc-guidedSteps__header">
                    <div class="HOA-misc-guidedSteps__header-text">
                        <span>{{paymentSchedule.nickname}} ({{paymentSchedule.frequency}})</span>
                    </div>
                </div>
                <div class="HOA-misc-guidedSteps__flex HOA-misc-guidedSteps__flex-padded">
                    <div class="Field HOA-misc-guidedSteps__flex-child HOA-make-payment-w100">
                        <label class="Field-label" for="newFixedDay">Calendar Day</label>
                        <div class="Select">
                            <select
                                    tid="newFixedDay"
                                    id="newFixedDay"
                                    name="newFixedDay"
                                    [(ngModel)]="fixedDay"
                                    (change)="refreshData()">
                                <option *ngFor="let day of daysOfMonth" [ngValue]="day">
                                    {{day}}
                                </option>
                            </select>
                            <span class="Select-arrow"></span>
                        </div>
                    </div>
                    <span class="HOA-make-guidedSteps_middleColumn"> </span>
                    <div class="Field HOA-misc-guidedSteps__flex-child">
                        <div class="HOA-flex-component HOA-make-payment-item-row">
                            <div class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter HOA-font-table-header">
                                Month
                            </div>
                            <div class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter HOA-font-table-header">
                                Date
                            </div>
                            <div class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter HOA-font-table-header">
                                Amount
                            </div>
                        </div>
                        <div *ngFor="let futurePayment of sortedFuturePayments; index as \$index" >
                            <div class="HOA-flex-component HOA-make-payment-item-row" >
                                <div class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter">
                                    <span>{{\$index+1}}</span>
                                </div>
                                <div class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter">
                                    <span>{{futurePayment.date.formattedFullDate}}</span>
                                </div>
                                <div class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter">
                                    <span>{{(futurePayment.total | currency) || "Next Assessment Amount"}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="u-pA5 HOA-view-schedule-detail
                                    HOA-font-fine-print
                                    u-app-hide-if-size-is-phone
                                    Box-footer--separate Grid--alignLeft">
                    Payments scheduled on weekends or holidays will process on the prior business day.
                </div>
                <div class="u-pA5 HOA-Checking-Detail-button-container" >
                    <button name="cancel"
                            id="cancel"
                            tid="cancel"
                            type="button"
                            class="Button Button--link "
                            [routerLink]="['/properties/scheduleEdit', paymentSchedule.id]"
                            [state]="{scheduleId: paymentSchedule.id}">
                        Cancel
                    </button>
                    <button name="submitSave"
                            id="submitSave"
                            tid="submitSave"
                            type="submit"
                            class="Button Button--blue "
                            [disabled]="submitDisabled()"
                            (click)="save()">
                        Save
                    </button>
                </div>
            </div>
        </form>
    </app-page-content>
</ng-container>`;
// Exports
module.exports = code;